var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNowIcon = function SvgNowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#now-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "now-icon_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#now-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "m11.095 5.903-4.193 4.193L4.906 8.1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "now-icon_svg__c",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M15.5 15.5V.5H.5v15z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#now-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M15.375 8A7.375 7.375 0 1 1 .625 8a7.375 7.375 0 0 1 14.75 0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "now-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgNowIcon;